import {
  GetCmSheetStateMachineResponse,
  UpdateCmSheetStateMachinewRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetStateMachineService = {
  async get(cmSheetId: number): Promise<GetCmSheetStateMachineResponse> {
    const response = await httpClient.get<GetCmSheetStateMachineResponse>(
      `v1/cm-sheets/${cmSheetId}/state-machine`,
    );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCmSheetStateMachinewRequest,
  ): Promise<void> {
    await httpClient.post(`v1/cm-sheets/${cmSheetId}/state-machine`, body);
  },
};

export default CmSheetStateMachineService;
